$(document).on('click', '.search-link', function () {
  if (!$('body').hasClass('search-results')) {
    $('body').toggleClass('search-overlay-active');
    $('.search-row').slideToggle(300);
  } else {
    $('.search-row input').focus();
  }
});